import { render, staticRenderFns } from "./ClientsidePagingSelector.vue?vue&type=template&id=a7e3868e&scoped=true"
import script from "./ClientsidePagingSelector.vue?vue&type=script&lang=ts"
export * from "./ClientsidePagingSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e3868e",
  null
  
)

export default component.exports